module.exports = __webpack_public_path__ + "static/training6-a8114c7796c7b49db5f8533a5a3245ba.jpg";